export default __webpack_public_path__ + "static/media/aud.56bf3efd.png";